// extracted by mini-css-extract-plugin
module.exports = {"resetFiltersBtn":"SalaryProfile_resetFiltersBtn__2Sxzt"};